module.exports = __webpack_public_path__ + "img/9788937833717.dc8a6cfc.jpg";